import { Root, TabsContent, TabsProps } from '@radix-ui/react-tabs';

import { CommonTabProps } from '../../types';

import { List } from './List';
import { Trigger } from './Trigger';

interface UnderscoreProps extends Omit<TabsProps, 'onChange' | 'onValueChange' | 'content'>, CommonTabProps {}

function Underscore({ index, value, data, content, disabled, onChange, ...props }: UnderscoreProps) {
  const currentValue = value ?? (index !== undefined ? data[index]?.key ?? data[index]?.value : undefined);

  return (
    <Root value={currentValue} onValueChange={onChange} {...props}>
      <List className="mb-4">
        {data.map((d) => {
          const _disabled = disabled ?? (typeof d.disabled === 'function' ? d.disabled(currentValue) : d.disabled);

          return (
            <Trigger active={currentValue === (d.key ?? d.value)} key={d.key ?? d.value} value={d.key ?? d.value} disabled={_disabled}>
              {d.title || d.value}
            </Trigger>
          );
        })}
      </List>
      {data.map((d) => (
        <TabsContent role="tabpanel" key={d.key ?? d.value} value={d.key ?? d.value}>
          {d.content ?? content}
        </TabsContent>
      ))}
    </Root>
  );
}

Underscore.Root = Root;
Underscore.List = List;
Underscore.Trigger = Trigger;
Underscore.Content = TabsContent;

export { Underscore };
